export default "/build/images/alqassim2.png?8ca65a918d77e84bf98ca42936e081f2";